import { normalizeRelations, resolveRelations } from '../helpers';
import { pascalCase } from '../../helpers';

// Some modules have data that does not need to go in relations
// Ex. tabs have no resource id and return [label, notes] which
// are not needed to be stored separately
const excluded = ['items', 'label', 'notes', 'sorted', 'perks'];

const state = {
  byId: {},
  allIds: []
};

const getters = {
  // Return a single article with the given id.
  find: (state, _, __, rootGetters) => id =>
    // Swap ID references with the resolved module objects.
    resolveRelations(
      state.byId[id],
      [...Object.keys(state.byId[id].data)].filter(
        key => !excluded.includes(key)
      ),
      rootGetters,
      { inData: true, inCart: true }
    )

  // Return a list of assignments in the order of `allIds`.
  // NOT NEEDED FOR assignments
  // list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  async addModule({ commit, dispatch }, module) {
    module.type = pascalCase(module.type);

    // Data fields
    const fields = [...Object.keys(module.data)].filter(
      key => !excluded.includes(key)
    );

    // Save module with relationships
    commit('add', normalizeRelations(module, fields, true));

    // Save module data by field (media, venues, categories etc.)
    fields.forEach(field => {
      // commit('media/addMedia', module.data.media);
      const moduleAddPath = `cart${pascalCase(field)}/add${pascalCase(field)}`;
      dispatch(moduleAddPath, module.data[field], { root: true });
    });
  }
};

const mutations = {
  add: (state, item) => {
    state.byId[item.id] = item;
    if (state.allIds.includes(item.id)) return;
    state.allIds.push(item.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
